// extracted by mini-css-extract-plugin
module.exports = {"notfount":"not-found_notfount__kkAU1","img":"not-found_img__S2QAj","title":"not-found_title__bOfUG","btn":"not-found_btn__Ks1Wo","des":"not-found_des__lbUJS"};